export const getStore = () => import(
  /* webpackChunkName: 'share' */
  './store');